<style lang="scss">
@import '../css/sub.scss';
</style>
<template>
  <div class="donga-audit">
    <audit-header></audit-header>
    <div class="audit-template sub-template">
      <div role="sub" class="audit-sub">
        <div id="sub-sections">
          <div class="visual-top reporting">
            <h2 class="page-tit">제보하기</h2>
            <p class="page-sub-tit pc-show">감사실과 제보자간의 쌍방향 소통방식으로 운영되며 동아쏘시오 그룹사 임직원 뿐만 아니라<br>고객, 협력회사 등 모든 이해관계자 여러분의 소중한 의견을 자유롭게 제안할 수 있는 곳으로 그룹사와 이해관계자<br>모두의 발전에 도움이 되도록 적극적인 참여 바랍니다.</p>
          </div>
          <div class="col-container pc-container">
            <div class="sub-contents">
              <div class="default-tab reporting-tab">
                <div class="tabs">
                  <button type="button" class="tab active">실명 제보</button>
                  <button type="button" class="tab" @click="showModal2=true">익명 제보</button>
                </div>
              </div>
                <section class="sub-section" id="reporting">
                  <div class="sub-column agree-column">
                    <h3 class="section-tit title">개인정보 수집•이용 동의</h3>
                    <p class="notice"><br><br>제보시스템(CLEAN:D) 이용을 위하여 아래와 같이 개인정보를 처리합니다.<br>
                    내용을 자세히 읽으신 후 동의 여부를 결정하시기 바랍니다.
                    </p>
                    <div class="description">
                      <ol class="desc-list">
                        <li><span class="bold">1. 수집하는 개인정보 항목</span>
                          <br>이름, 전화번호, 이메일
                        </li>
                        <li>
                          <span class="bold">2. 개인정보의 수집 및 이용목적</span>
                          <br>- 실명제보 접수 내용의 사실관계 확인
                          <br>- 실명제보 처리 결과 안내
                          <br>- 실명제보 처리 결과에 따른 포상
                          <br>- 실명제보 처리 결과에 따른 형사 조치(고소•고발) 시 인적증거 등록

                        </li>
                        <li>
                          <span class="bold">3. 개인정보의 보유 및 이용기간</span>
                          <br>수집•이용목적 달성 시 지체 없이 파기

                        </li>
                      </ol>
                    </div>
                    <div class="agree-area">
                      <p class="notice">※ 위의 개인정보 수집•이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 실명제보 이용에 제한을 받을 수 있습니다.</p>
                      <div class="agree-radio-area">
                        <span class="radio-half">
                          <input type="radio" class="default-radio" id="agree-radio-first" name="porsonal-inform-first" value="yes" v-model="realName">
                          <label for="agree-radio-first" class="default-label">동의합니다.</label>
                        </span>
                        <span class="radio-half">
                          <input type="radio" class="default-radio" id="agree-radio-second" name="porsonal-inform-first" value="no" v-model="realName">
                          <label for="agree-radio-second" class="default-label">동의하지 않습니다.</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="sub-column agree-column second">
                    <h3 class="section-tit title">개인정보 제3자 제공 동의</h3>
                    <p class="notice"><br><br>제보시스템(CLEAN:D) 이용을 위하여 아래와 같이 개인정보를 처리합니다.
                    내용을 자세히 읽으신 후 동의 여부를 결정하시기 바랍니다.
                    </p>
                    <div class="description">
                      <ol class="desc-list">
                        <li><span class="bold">1. 개인정보를 제공받는 자</span><br>동아에스티, 동아제약, 에스티젠바이오, 동아오츠카, 용마로지스, 에스티팜, 수석, 한국신동공업, 동천수, 참메드, 앱티스,  디에이인포메이션, 아벤종합건설
                        </li>
                        <li>
                          <span class="bold">2. 개인정보를 제공받는 자의 개인정보 이용목적</span>
                          <br>- 실명제보 접수 내용의 사실관계 확인
                          <br>- 실명제보 처리 결과 안내
                          <br>- 실명제보 처리 결과에 따른 포상
                          <br>- 실명제보 처리 결과에 따른 형사 조치(고소•고발) 시 인적증거 등록
                        </li>
                        <li>
                          <span class="bold">3. 제공하는 개인정보의 항목</span><br>이름, 전화번호, 이메일
                        </li>
                        <li>
                          <span class="bold">4. 개인정보를 제공받는 자의 개인정보 보유 및 이용기간</span><br>수집•이용목적 달성 시 지체 없이 파기
                        </li>
                      </ol>
                    </div>
                    <div class="agree-area">
                      <p class="notice">※ 위의 개인정보 수집•이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 실명제보 이용에 제한을 받을 수 있습니다.</p>
                      <div class="agree-radio-area">
                        <span class="radio-half">
                          <input type="radio" class="default-radio" id="agree-radio-third" name="porsonal-inform-second" value="yes" v-model="anonymousName">
                          <label for="agree-radio-third" class="default-label">동의합니다.</label>
                        </span>
                        <span class="radio-half">
                          <input type="radio" class="default-radio" id="agree-radio-fourth" name="porsonal-inform-second" value="no" v-model="anonymousName">
                          <label for="agree-radio-fourth" class="default-label">동의하지 않습니다.</label>
                        </span>
                      </div>
                    </div>
                    <modal v-if="showModal" @close="showModal=false">
                      <h3 style="font-size: 17px;" slot="body">Clean :D의 모든 제보는 접수순서에 따라 순차적으로 처리함을 원칙으로 합니다.접수부터 사실관계 확인 및 조치완료까지 최소 2주부터 최대 1개월 이상 소요될 수 있으니 참고하시기 바랍니다.<br>(제보사항이 구체적일수록 처리기간을 단축할 수 있습니다.)<br>최대한 신속하고 정확하게 처리하겠습니다.</h3>
                      <button slot="footer" type="button" class="modal-button" @click="goPublicPage">
                          확인
                      </button>
                    </modal>
                    <modal v-if="showModal2" @close="showModal2=false">
                      <h3 style="font-size: 17px;" slot="body">Clean :D의 모든 제보는 접수순서에 따라 순차적으로 처리함을 원칙으로 합니다.접수부터 사실관계 확인 및 조치완료까지 최소 2주부터 최대 1개월 이상 소요될 수 있으니 참고하시기 바랍니다.<br>(제보사항이 구체적일수록 처리기간을 단축할 수 있습니다.)<br>최대한 신속하고 정확하게 처리하겠습니다.</h3>
                      <button slot="footer" type="button" class="modal-button" @click="goPrivatePage">
                          확인
                      </button>
                    </modal>
                    <div class="agree-btn-area">
                      <button type="button" class="agree-btn" @click="agreeRealName">다음</button>
                    </div>
                  </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
import Modal from '@/components/Modal'
export default {
  name: 'Reporting',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter,
    'modal': Modal
  },
  data () {
    return {
      realName: '',
      anonymousName: '',
      showModal: false,
      showModal2: false
    }
  },
  methods: {
    agreeRealName: function () {
      if (this.realName === 'yes' && this.anonymousName === 'yes') {
        this.showModal = true
      } else {
        alert('개인정보 수집및 처리, 제 3자 제공의 동의시 진행됩니다.')
      }
    },
    goPrivatePage () {
      this.$router.push('/reportsecond02')
    },
    goPublicPage () {
      this.$router.push('/reportsecond')
    }
  }
}
</script>

<style scoped>
.modal-button {
  font-size: 18px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reporting.vue